import * as React from "react"
import { cva } from "class-variance-authority"

import { cn } from "@/lib/utils"

const alertVariants = cva(
  "relative grid w-full grid-cols-[auto_1fr] items-start gap-x-3 gap-y-1 rounded-md border-l-4 px-4 py-3 text-sm [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:row-span-1",
  {
    variants: {
      variant: {
        default:
          "border-border bg-muted text-foreground",
        info:
          "border-sky-600 bg-sky-600/10 text-sky-700 dark:border-sky-400 dark:bg-sky-400/10 dark:text-sky-300",
        warning:
          "border-amber-600 bg-amber-600/10 text-amber-700 dark:border-amber-400 dark:bg-amber-400/10 dark:text-amber-300",
        destructive:
          "border-destructive bg-destructive/10 text-destructive dark:border-destructive",
        success:
          "border-emerald-600 bg-emerald-600/10 text-emerald-700 dark:border-emerald-400 dark:bg-emerald-400/10 dark:text-emerald-300",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Alert({ className, variant, ...props }) {
  return (
    <div
      role="alert"
      data-slot="alert"
      className={cn(alertVariants({ variant }), className)}
      {...props}
    />
  )
}

function AlertTitle({ className, ...props }) {
  return (
    <div
      data-slot="alert-title"
      className={cn("col-start-2 font-medium tracking-tight", className)}
      {...props}
    />
  )
}

function AlertDescription({ className, ...props }) {
  return (
    <div
      data-slot="alert-description"
      className={cn("col-start-2 text-sm opacity-80", className)}
      {...props}
    />
  )
}

export { Alert, AlertTitle, AlertDescription, alertVariants }
